import { useCompare } from "../context/CompareContext";
import { useSubscription } from "../context/SubscriptionContext";

export default function CompareButton({ provider }) {
  const { toggleCompare, isInCompareList, compareList } = useCompare();
  const { isPro, setUpgradeMessage, setShowUpgradeModal } = useSubscription();

  const inList = isInCompareList(provider.npi);
  const full = compareList.length >= 3 && !inList;

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!isPro) {
      setUpgradeMessage("Comparing providers is a Pro feature. Upgrade to compare up to 3 providers side by side.");
      setShowUpgradeModal(true);
      return;
    }
    toggleCompare(provider);
  }

  return (
    <button
      onClick={handleClick}
      className={`text-xs px-3 py-1 rounded-lg border transition-all ${
        inList
          ? "bg-gold-500/20 border-gold-500/40 text-gold-300"
          : full
          ? "border-white/5 text-white/20 cursor-not-allowed"
          : "border-white/20 text-white/40 hover:border-gold-500/40 hover:text-gold-300"
      }`}
    >
      {inList ? "✓ Compare" : "+ Compare"}
    </button>
  );
}